import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container"];

  show(message) {
    //トーストメッセージを構築
    const messageText = Object.assign(document.createElement("p"), {
      className: "toast-message__text",
      textContent: message,
    });
    const messageInner = Object.assign(document.createElement("div"), {
      className: "toast-message__inner",
    });
    messageInner.appendChild(messageText);

    const closeButton = Object.assign(document.createElement("button"), {
      className: "toast-message__close",
      textContent: "通知を閉じる",
    });
    closeButton.setAttribute("data-action", "toast#close");

    const messageBase = Object.assign(document.createElement("div"), {
      className: "toast-message",
    });
    messageBase.setAttribute("aria-live", "polite");
    messageBase.appendChild(messageInner);
    messageBase.appendChild(closeButton);

    const toast = Object.assign(document.createElement("div"), {
      className: "toast",
    });
    toast.setAttribute("data-controller", "toast");
    toast.appendChild(messageBase);

    this.containerTarget.appendChild(toast);
  }
}
